import { render, staticRenderFns } from "./Excerpts.vue?vue&type=template&id=55853a17&scoped=true"
import script from "./Excerpts.vue?vue&type=script&lang=js"
export * from "./Excerpts.vue?vue&type=script&lang=js"
import style0 from "./Excerpts.vue?vue&type=style&index=0&id=55853a17&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55853a17",
  null
  
)

export default component.exports